const cntr = "center-center"

const ngxUiLoaderConfig: NgxUiLoaderConfig =
{
    "bgsColor": "red",
    "bgsOpacity": 0.5,
    "bgsPosition": "bottom-right",
    "bgsSize": 60,
    "bgsType": "ball-spin-clockwise",
    "blur": 5,
    "delay": 0,
    "fastFadeOut": true,
    "fgsColor": "red",
    "fgsPosition": cntr,
    "fgsSize": 60,
    "fgsType": "ball-spin-clockwise",
    "gap": 24,
    "logoPosition": cntr,
    "logoSize": 120,
    "logoUrl": "",
    "masterLoaderId": "master",
    "overlayBorderRadius": "0",
    "overlayColor": "rgba(40, 40, 40, 0.8)",
    "pbColor": "red",
    "pbDirection": "ltr",
    "pbThickness": 3,
    "hasProgressBar": true,
    "text": "",
    "textColor": "#FFFFFF",
    "textPosition": cntr,
    "maxTime": -1,
    "minTime": 300
}

import { APP_INITIALIZER, inject, NgModule, provideAppInitializer } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FooterComponent } from './core/footer/footer.component';
import { HeaderComponent } from './core/header/header.component';
import { ToolbarComponent } from './core/toolbar/toolbar.component';
// for dropdowns, any animations in web etc
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// mat list,icon,menu
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { AgGridModule } from 'ag-grid-angular';
import { HomeComponent } from './pages/home/home.component';
import { AssignedUserComponent } from './pages/kpi/assigned-user/assigned-user.component';
import { DomicileComponent } from './pages/kpi/domicile/domicile.component';
import { FgaModule } from './fga/fga.module';
//charts

import { MatDialogModule } from '@angular/material/dialog';
import { NgChartsModule } from 'ng2-charts';
import {
    NgxUiLoaderConfig, NgxUiLoaderModule
} from "ngx-ui-loader";
import { AddContingencyDialogComponent } from './core/dialogs/add-contingency-dialog/add-contingency-dialog.component';
import { AddPeriodDialogComponent } from './core/dialogs/add-period-dialog/add-period-dialog.component';
import { AddQueueDialogComponent } from './core/dialogs/add-queue-dialog/add-queue-dialog.component';
import { AddShuttleDialogComponent } from './core/dialogs/add-shuttle-dialog/add-shuttle-dialog.component';
import { AddTierDialogComponent } from './core/dialogs/add-tier-dialog/add-tier-dialog.component';
import { CopyTierDialogComponent } from './core/dialogs/copy-tier-dialog/copy-tier-dialog.component';
import { DeleteDialogComponent } from './core/dialogs/delete-dialog/delete-dialog.component';
import { ExclusionParametersDialogComponent } from './core/dialogs/exclusion-parameters-dialog/exclusion-parameters-dialog.component';
import { HistoryLogsDialogComponent } from './core/dialogs/history-logs-dialog/history-logs-dialog.component';
import { UploadFilesDialogComponent } from './core/dialogs/upload-files-dialog/upload-files-dialog.component';
import { BtnCellRendererDeleteClipboard } from './core/grid/btn-cell-render-delete-clipboard';
import { BtnCellRendererDelete } from './core/grid/btn-cell-render-delete.component';
import { BtnCellRendererEditDelete } from './core/grid/btn-cell-render-edit-delete';
import { BtnCellRendererSignup } from './core/grid/btn-cell-render-signup';
import { BtnCellRendererTick } from './core/grid/btn-cell-render-tick';
import { BtnCellRendererUnAssign } from './core/grid/btn-cell-render-unassign.component';
import { BtnCellRenderer } from './core/grid/btn-cell-render.component';
import { CheckboxCellRenderer } from './core/grid/checkbox-cell-render';
import { GridCheckboxEditorComponent } from './core/grid/grid-checkbox-editor.component';
import { GridDropdownEditorComponent } from './core/grid/grid-dropdown-edit.component';
import { GridRefreshComponent } from './core/grid/grid-refresh.component';
import { GridSingleviewLinkComponent } from './core/grid/grid-singleview-link.component';
import { GridTextEditorComponent } from './core/grid/grid-text-edit.component';
import { HeaderCheckboxComponent } from './core/grid/header-checkbox.component';
import { RowCheckboxComponent } from './core/grid/row-checkbox.component';
import { LiosNavbarComponent } from './core/lios-navbar/lios-navbar.component';
import { GroupiDetailComponent } from './pages/group-i/detail-level/groupidetails.component';
import { EWConfigurationComponent } from './pages/management/ewconfiguration/ewconfiguration.component';
import { HistoryComponent } from './pages/management/history/history.component';
import { PeriodsComponent } from './pages/management/periods/periods.component';
import { TierSetupComponent } from './pages/management/tiersetup/tiersetup.component';
import { NotificationMessageComponent } from './pages/notification-message/notification-message.component';
import { ContingencyMasterTablesComponent } from './pages/pcs/contingency-master-tables/contingency-master-tables.component';
import { ContingencyPCSComponent } from './pages/pcs/contingency-pcs/contingency-pcs.component';
import { ConstantsService } from './service/constants.service';
import { BreadcrumbComponent } from './core/breadcrumb/breadcrumb.component';
import { InjectionToken } from '@angular/core';


//Msal
import { InteractionType, IPublicClientApplication, PublicClientApplication } from '@azure/msal-browser';
import { environment } from 'src/environments/environment';
import { Constants } from './constants';
import { DateFilterComponent } from './core/dialogs/date-filter/date-filter.component';
import { RouteCommentsComponent } from './core/dialogs/route-comments/route-comments.component';
import { BtnCellRendererComments } from './core/grid/btn-cell-render-comments.component';
import { MsalBroadcastService, MsalGuard, MsalInterceptor, MsalService, MSAL_INSTANCE } from './msal';
import { MSAL_GUARD_CONFIG, MSAL_INTERCEPTOR_CONFIG } from './msal/constants';
import { MsalInterceptorConfig } from './msal/msal.interceptor.config';
import { GroupirouteComponent } from './pages/group-i/route-level/groupiroute.component';
import { GroupitierComponent } from './pages/group-i/tier-level/groupitier.component';
import { PeriodsDropdownComponent } from './pages/periods-dropdown/periods-dropdown.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FgaService } from './fga/fga.service';
import { UnauthorizedComponent } from './pages/unauthorized/unauthorized.component';
import { provideApollo } from 'apollo-angular';
import { InMemoryCache } from '@apollo/client/cache';
import {
    MsalInterceptorConfiguration,
    MsalGuardConfiguration,
  } from '@azure/msal-angular';

  import { ModuleRegistry, AllCommunityModule } from 'ag-grid-community';
import { AddParamsInterceptor } from './add-params.interceptor';
    
  ModuleRegistry.registerModules([ AllCommunityModule ]);
export function MSALInstanceFactory(): IPublicClientApplication {
    return new PublicClientApplication({
        auth: {
            clientId: environment.CLIENT_ID,
            authority: environment.TENANT_ID,
            redirectUri: environment.REDIRECT_URL
        }
    });
}


export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
    const protectedResourceMap = new Map<string, Array<string>>();
    protectedResourceMap.set(
      environment.REDIRECT_URL,
      environment.SCOPES
    );
  
    return {
      interactionType: InteractionType.Redirect,
      protectedResourceMap,
    };
  }

  export function MSALGuardConfigFactory(): MsalGuardConfiguration {
    return {
      interactionType: InteractionType.Redirect,
      authRequest: {
        scopes: [...environment.SCOPES],
      },
      loginFailedRoute: '/unauthorized',
    };
  }


  



export function initializeMsal(instance: IPublicClientApplication): () => Promise<void> {
    return () => instance.initialize();
}

export const FGA_API_ENDPOINT = new InjectionToken<string>('FGA_API_ENDPOINT');



//primeng 
@NgModule({
    declarations: [
        AppComponent,
        HeaderComponent,
        ToolbarComponent,
        FooterComponent,
        HomeComponent,
        DateFilterComponent,
        GroupitierComponent,
        GroupiDetailComponent,
        GroupirouteComponent,
        TierSetupComponent,
        BtnCellRenderer,
        BtnCellRendererTick,
        CheckboxCellRenderer,
        BtnCellRendererEditDelete,
        BtnCellRendererDeleteClipboard,
        RowCheckboxComponent,
        HeaderCheckboxComponent,
        GridRefreshComponent,
        GridTextEditorComponent,
        GridDropdownEditorComponent,
        GridCheckboxEditorComponent,
        CopyTierDialogComponent,
        AddTierDialogComponent,
        AddShuttleDialogComponent,
        DeleteDialogComponent,
        ExclusionParametersDialogComponent,
        HistoryLogsDialogComponent,
        AddQueueDialogComponent,
        AddPeriodDialogComponent,
        UploadFilesDialogComponent,
        EWConfigurationComponent,
        HistoryComponent,
        ContingencyPCSComponent,
        ContingencyMasterTablesComponent,
        NotificationMessageComponent,
        PeriodsComponent,
        DomicileComponent,
        AssignedUserComponent,
        AddContingencyDialogComponent,
        LiosNavbarComponent,
        BtnCellRendererSignup,
        BtnCellRendererUnAssign,
        PeriodsDropdownComponent,
        GridSingleviewLinkComponent,
        RouteCommentsComponent, CheckboxCellRenderer, BtnCellRenderer,
        BtnCellRendererTick, BtnCellRendererEditDelete,
        BtnCellRendererDeleteClipboard, BtnCellRendererDelete,
        GridRefreshComponent, RowCheckboxComponent,
        HeaderCheckboxComponent, GridTextEditorComponent,
        GridDropdownEditorComponent, GridCheckboxEditorComponent,
        BtnCellRendererComments, GridSingleviewLinkComponent, UnauthorizedComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        MatIconModule,
        MatListModule,
        MatMenuModule,
        MatTooltipModule,
        BrowserAnimationsModule,
        AgGridModule,
        NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
        MatDialogModule,
        MatSlideToggleModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        ReactiveFormsModule,
        NgxMatSelectSearchModule,
        MatCheckboxModule,
        NgChartsModule,
        MatTabsModule,
        FormsModule,
        FgaModule,
        BreadcrumbComponent], providers: [ConstantsService, Constants,
            {
                provide: HTTP_INTERCEPTORS,
                useClass: MsalInterceptor,
                multi: true
            },
            {
                provide: HTTP_INTERCEPTORS,
                useClass: AddParamsInterceptor,
                multi: true
            },
            {
                provide: MSAL_INSTANCE,
                useFactory: MSALInstanceFactory
            },
            provideAppInitializer(() => {
                const msalInstance = inject(MSAL_INSTANCE);
                return msalInstance.initialize();
              }),
            {
                provide: MSAL_GUARD_CONFIG,
                useFactory: MSALGuardConfigFactory
            },
            {
                provide: MSAL_INTERCEPTOR_CONFIG,
                useFactory: MSALInterceptorConfigFactory
            },
            MsalService,
            MsalGuard,
            MsalBroadcastService, provideHttpClient(withInterceptorsFromDi()),
            provideApollo(() => {
                return { cache: new InMemoryCache() }
            }),
            { provide: FGA_API_ENDPOINT, useValue: environment.APM_DS_URI },]
})
export class AppModule { }
